"use client";
import { FormGroup, MultipleSelect, SelectOption } from '@develos/next-components';
import { useTranslations } from '@develos/next-library';
import React, {  } from 'react';
import { useVehicleCategories } from '@/hooks';

type Props = {
    value: number[],
    handleChange: (event: React.ChangeEvent<any>) => void
}

const VehicleCategoriesFilter = ({ handleChange, value}: Props) => {
    const { translate } = useTranslations();
    const { isLoading, categories } = useVehicleCategories();
    const options: SelectOption<number>[] = categories?.map(x => ({ label: x.name, value: x.id })) ?? [];
    
    return (
        <FormGroup label={translate('Kategorie')}>
            <MultipleSelect
                options={options}
                handleChange={handleChange}
                value={value}
                placeholder={translate('Wybierz kategorie')}
                isLoading={isLoading}
            />
        </FormGroup>
    );
};

export default VehicleCategoriesFilter;